import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "./testimonial.css";

const testimonials = [
  { id: 1, name: "Ramesh Kumar", project: "Luxury Home Interior", location: "Chennai", review: "First Sky Infra transformed our house into a luxurious and elegant space. The attention to detail in every corner, from the living room to the bedrooms, exceeded our expectations. Their team ensured a seamless and high-quality execution!" },
  { id: 2, name: "Priya Mehta", project: "Modular Kitchen Design", location: "Bangalore", review: "We wanted a modern and functional kitchen, and First Sky Infra delivered exactly that! The modular design, space optimization, and premium finishes have made our cooking experience effortless and enjoyable." },
  { id: 3, name: "Anil Sharma", project: "Corporate Office Interiors", location: "Chennai", review: "Our new office reflects professionalism and innovation, thanks to First Sky Infra. The ergonomic furniture, lighting, and smart space planning have created a productive work environment for our team." },
  { id: 4, name: "Sneha Agarwal", project: "Retail Showroom Interior (Fashion & Apparel)", location: "Chennai", review: "The showroom design enhanced our brand image with its stylish layout and elegant lighting. Customers love the inviting ambiance, and sales have improved significantly!" },
  { id: 5, name: "Rajesh Gupta", project: "Luxury Hotel & Resort Interiors", location: "Kerala", review: "From the lobby to the suites, every space in our resort now exudes luxury and comfort. First Sky Infra captured the perfect blend of aesthetics and functionality, impressing our guests." },
  { id: 6, name: "Dr. Sandeep Verma", project: "Healthcare & Clinic Interiors", location: "Hyderabad", review: "The interior design of our clinic is both welcoming and highly functional. The patient waiting area, consultation rooms, and lighting create a calming atmosphere, which has enhanced our patient experience." },
  { id: 7, name: "Rohit Malhotra", project: "High-End Restaurant Interior", location: "Bangalore", review: "First Sky Infra designed our restaurant with a perfect balance of aesthetics and comfort. The ambiance is inviting, the seating is well-planned, and the lighting enhances the overall dining experience." },
  { id: 8, name: "Kavita Nair", project: "Educational Institution Interiors (Classrooms & Libraries)", location: "Chennai", review: "The modern classroom and library designs have created an inspiring learning environment for our students. Their thoughtful approach to space planning and acoustics has truly enhanced our institute." },
  { id: 9, name: "Ashok Reddy", project: "Luxury Villa Interiors", location: "Hyderabad", review: "Every room in our villa has been designed with elegance and sophistication. The customized furniture, lighting, and décor perfectly match our vision, making it a dream home." },
  { id: 10, name: "Naveen Kapoor", project: "Home Theatre & Entertainment Room", location: "Pondicherry", review: "First Sky Infra created an immersive home theatre experience for us. The acoustics, lighting, and seating arrangement make it feel like a real cinema in the comfort of our home!" }
];



export default function Testimonials() {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prevIndex) => (prevIndex + 2) % testimonials.length); // Move by 2 for web view
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="testimonial-container" style={{ marginTop:"50px"}}>
      <h3 className="heading-head">What Our Clients Say</h3>
      {/* <div className="underline-service"></div> */}
      <div className="testimonial-box">
        <AnimatePresence>
          <motion.div
            key={testimonials[index].id}
            initial={{ opacity: 0, x: 100 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: -50 }}
            transition={{ duration: 0.5 }}
            className="testimonial-content"
          >
<p className="testimonial-project">
  {testimonials[index].project} - {testimonials[index].location}
</p>            <p className="testimonial-text">"{testimonials[index].review}"</p>
            <p className="testimonial-name">- {testimonials[index].name}</p>
          </motion.div>
        </AnimatePresence>
      </div>
      <div className="testimonial-buttons">
  {testimonials.map((_, i) => (
    <button
      key={i}
      className={`testimonial-button ${i === index ? "active" : ""}`}
      onClick={() => setIndex(i)}
    />
  ))}
</div>

    </div>
  );
}
